import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import axios from 'axios';
import Config from '../config';
import { getCookie, clearCookies, setCookie, recoverCookies } from '../util/cookie';
axios.defaults.headers.delete['Content-Type'] = 'application/json';
axios.defaults.timeout = 10000;
var deleteAd = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(listId, deletionReason) {
    var allCookies, testAbGroups, loginIdentifier, sessionId, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            allCookies = getCookie();
            testAbGroups = getCookie('TestAB_Groups');
            loginIdentifier = getCookie('loginIdentifier');
            sessionId = getCookie('session_id');
            clearCookies();
            setCookie('loginIdentifier', loginIdentifier);
            setCookie('TestAB_Groups', testAbGroups);
            setCookie('session_id', sessionId);
            _context.next = 10;
            return axios.delete(Config.DELETION_URL, {
              data: {
                list_id: listId,
                deletion_reason: deletionReason
              },
              withCredentials: true
            });
          case 10:
            response = _context.sent;
            recoverCookies(allCookies);
            return _context.abrupt('return', response);
          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));
  return function deleteAd(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var deleteAdByAdId = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(adId, deletionReason) {
    var allCookies, testAbGroups, loginIdentifier, sessionId, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            allCookies = getCookie();
            testAbGroups = getCookie('TestAB_Groups');
            loginIdentifier = getCookie('loginIdentifier');
            sessionId = getCookie('session_id');
            clearCookies();
            setCookie('loginIdentifier', loginIdentifier);
            setCookie('TestAB_Groups', testAbGroups);
            setCookie('session_id', sessionId);
            _context2.next = 10;
            return axios.delete(Config.DELETION_URL, {
              data: {
                ad_id: adId,
                deletion_reason: deletionReason
              },
              withCredentials: true
            });
          case 10:
            response = _context2.sent;
            recoverCookies(allCookies);
            return _context2.abrupt('return', response);
          case 13:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));
  return function deleteAdByAdId(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var AdDeletionService = {
  deleteAd: deleteAd,
  deleteAdByAdId: deleteAdByAdId
};
export default AdDeletionService;